import * as React from "react";
import Drawer from "@mui/material/Drawer";

export default function ChatDrawer({ open, onClose, children }) {
  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{ className: "bottom-drawer" }}
    >
      {children}
    </Drawer>
  );
}
